import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import c21Ratings from "../../../../src/data/articles/cube-prospective-commander-2021/c21-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  c21Ratings,
  ProspectiveIntro,
  React
};